/**
 * LD Cart Indicator - Dynamic cart item indicator
 * ==============================================
 * 
 * Shows/hides cart indicator dot when items are added/removed from cart
 * Uses best practices for Shopify cart updates
 * 
 * FIXED: No more flash on page load - dot is initialized with correct state
 */

class LDCartIndicator {
  constructor() {
    this.cartIndicator = null;
    this.init();
  }

  init() {
    // Find cart indicator elements
    this.cartIndicator = document.querySelector('.ld-header-03__action-item-dot');
    this.mobileCartIndicator = document.querySelector('.ld-header-03__mobile-cart-dot');
    
    if (!this.cartIndicator && !this.mobileCartIndicator) {
      console.log('LD Cart Indicator: Cart dot elements not found');
      return;
    }

    // Listen for cart updates
    this.setupCartListeners();
    
    // Initial check
    this.updateCartIndicator();
  }

  setupCartListeners() {
    // Listen for Shopify cart updates
    document.addEventListener('cart:updated', (event) => {
      this.updateCartIndicator();
    });

    // Listen for cart drawer updates
    document.addEventListener('cart:drawer:updated', (event) => {
      this.updateCartIndicator();
    });

    // Listen for cart API updates
    document.addEventListener('cart:api:updated', (event) => {
      this.updateCartIndicator();
    });

    // Listen for form submissions that might update cart
    document.addEventListener('submit', (event) => {
      if (event.target.matches('form[action*="cart/add"]')) {
        // Wait a bit for cart to update
        setTimeout(() => {
          this.updateCartIndicator();
        }, 500);
      }
    });

    // Listen for AJAX cart updates
    document.addEventListener('ajax:cart:updated', (event) => {
      this.updateCartIndicator();
    });
  }

  updateCartIndicator() {
    if (!this.cartIndicator) {
      return;
    }

    // Get cart state from Shopify
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count > 0) {
          this.showCartIndicator();
        } else {
          this.hideCartIndicator();
        }
      })
      .catch(error => {
        console.log('LD Cart Indicator: Error fetching cart state:', error);
      });
  }

  showCartIndicator() {
    if (this.cartIndicator) {
      this.cartIndicator.style.display = 'block';
      this.cartIndicator.style.opacity = '1';
    }
    if (this.mobileCartIndicator) {
      this.mobileCartIndicator.style.opacity = '1';
    }
  }

  hideCartIndicator() {
    if (this.cartIndicator) {
      this.cartIndicator.style.display = 'none';
      this.cartIndicator.style.opacity = '0';
    }
    if (this.mobileCartIndicator) {
      this.mobileCartIndicator.style.opacity = '0';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LDCartIndicator();
  });
} else {
  new LDCartIndicator();
} 